import React from "react";

// Centred card for the signed-out screens: login, two-step, password links.
const AuthLayout = ({ title, description, children, footer }) => (
  <main className="cc-auth cc-bb">
    <div className="cc-auth__card">
      <img className="cc-auth__logo" src="/images/ROUTES_LOGO.png" alt="Routes" />
      {title && <h1 className="cc-auth__title">{title}</h1>}
      {description && <p className="cc-auth__description">{description}</p>}
      {children}
    </div>
    {footer && <div className="cc-auth__footer">{footer}</div>}
  </main>
);

export default AuthLayout;
